import React, { FunctionComponent, ReactNode } from 'react'

export interface Props {
  title: ReactNode
  content: ReactNode
}

export const AdminBannerInfoCard: FunctionComponent<Props> = ({
  title,
  content,
}) => (
  <div data-test="user-banner-info-card" className="user-banner__info-card">
    <h4 className="user-banner__info-card__title">{title}</h4>
    <hr className="user-banner__info-card__hr" />
    <div>{content}</div>
  </div>
)

AdminBannerInfoCard.displayName = 'AdminBannerInfoCard'
